module.exports = __webpack_public_path__ + "img/president_message_en.b2ec54d.jpg";